import { ARRMGR_CLOUDINARY_ALLOWED, ARRMGR_CLOUDINARY_URL, getFrontUrl, getMediaUrl } from "@rhinov/asset-manager-service";
import { Coating, CoatingArea, Component, ComponentConstants, Events, eventsManager, FloorCoatingArea, JoineryType, TechnicalElementType } from "@rhinov/savane-js";




export class ComponentController {

    component: Component;
    
    constructor (component: Component) {
        this.component = component;
    }

    /**
    * Retrieve preview image to display in component view
    **/
    getPreview(): string {
        var component = this.component;
        var infos = (component as any).infos;

        if (!component) {
            return ('');
        }

        var previewPath = "/" + infos._id + "/medias/previews/";

        switch (component.componentType) {
            case ComponentConstants.ComponentType.Coating:
            case ComponentConstants.ComponentType.CoatingArea:
            case ComponentConstants.ComponentType.FloorCoatingArea:
                var coating = component as Coating | CoatingArea | FloorCoatingArea;
                var colorIdx = coating.colorIndex;

                previewPath = "coatings" + previewPath;

                if (!isNaN(colorIdx) && (colorIdx !== 0)) {
                    previewPath += 'preview' + coating.colorIndex + '-sm.webp';
                }
                else {
                    previewPath += 'preview1-sm.webp';
                }
                break;
            case ComponentConstants.ComponentType.JoineryType:
                        previewPath = 'joineries' + previewPath + 'preview1-sm.webp';
                        break;
            case ComponentConstants.ComponentType.TechnicalElementType:
                        previewPath = 'technicalElements' + previewPath + 'preview1-sm.webp';
                        break;

            default:
                previewPath += 'preview1-sm.webp';
                break;
        }

        previewPath = getMediaUrl() + previewPath;
        if (ARRMGR_CLOUDINARY_ALLOWED) {
            previewPath = ARRMGR_CLOUDINARY_URL + infos._id + "/medias/previews/preview1-sm.webp";
        }

        return (previewPath);
    };

    getName(): string {
        if ((this.component as any).infos){
            return (this.component as any).infos.name;
        }
        return "";
    }

    openComponentDetail(comp: Component) {
        var path: string = '';
        var id: string = '';
        switch(comp.componentType)
        {
            case ComponentConstants.ComponentType.CoatingArea:
            case ComponentConstants.ComponentType.FloorCoatingArea:
            case ComponentConstants.ComponentType.Coating:
                path = "coatings/";
                id = (comp as Coating).coatingId;
                break;
            case ComponentConstants.ComponentType.JoineryType:
                path = "joineries/";
                id = (comp as JoineryType).joineryTypeId;
                break;
            case ComponentConstants.ComponentType.TechnicalElementType:
                path = "technical-elements/";
                id = (comp as TechnicalElementType).technicalElementTypeId;
                break;
        }
        window.open((getFrontUrl() + path + id));
    };


    copyComponentAssetID = function(component: Component) {
        var id: string = '';
        switch(component.componentType) 
        {
            case ComponentConstants.ComponentType.CoatingArea:
            case ComponentConstants.ComponentType.FloorCoatingArea:
            case ComponentConstants.ComponentType.Coating:
                id = (component as Coating).coatingId;
                break;
                
            case ComponentConstants.ComponentType.JoineryType:
                id = (component as JoineryType).joineryTypeId;
                break;
            case ComponentConstants.ComponentType.TechnicalElementType:
                id = (component as TechnicalElementType).technicalElementTypeId;
                break; 
        }
        navigator.clipboard.writeText(id);
        eventsManager.instance.dispatch(Events.DISPLAY_TOASTER, { message: 'ID copié dans le presse papier.' });
    }

    openComponentAssetIssue(component: Component) {
        var id: string = '';
        switch(component.componentType) 
        {
            case ComponentConstants.ComponentType.CoatingArea:
            case ComponentConstants.ComponentType.FloorCoatingArea:
            case ComponentConstants.ComponentType.Coating:
                id = (component as Coating).coatingId;
                break;
                
            case ComponentConstants.ComponentType.JoineryType:
                id = (component as JoineryType).joineryTypeId;
                break;
            case ComponentConstants.ComponentType.TechnicalElementType:
                id = (component as TechnicalElementType).technicalElementTypeId;
                break; 
        }
        window.open(getFrontUrl() + 'create-issue?asset=' + id);
    }
}